export default "__VITE_ASSET__BPRkMeU9__"